"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStore = exports.registerStore = void 0;
var _store = null;
function registerStore(store) {
    if (!!_store) {
        console.warn('[vuex-typed] Store was already registered! This method should not be called more than once.');
    }
    _store = store;
}
exports.registerStore = registerStore;
function getStore() {
    if (!_store) {
        console.error('[vuex-typed] Store wasn\'t registered!');
    }
    return _store;
}
exports.getStore = getStore;
